import { Controller } from "@hotwired/stimulus"

// Persists the Ansicht menu's chip-sort choice onto the account when the form is applied.
// The form itself submits as a GET and only shapes the render: the stored preference is
// written exclusively through this PATCH, so a copied or bookmarked board URL carrying a
// chip_sort param can never rewrite the preference of whoever opens it.
export default class extends Controller {
  static values = { url: String }

  persist() {
    const checked = this.element.querySelector('input[name="chip_sort"]:checked')
    if (!checked) return

    const token = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    // keepalive: the GET navigation follows immediately, and the write must survive it.
    // Fire-and-forget — on failure the next render simply falls back to the old preference.
    fetch(this.urlValue, {
      method: "PATCH",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ chip_sort: checked.value }),
    }).catch(() => {})
  }
}
